<form [formGroup]="jobOrderSearchForm">
  <div class="searchBox input-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      />
    </svg>
    <input
      #searchBox
      [ngClass]="{ expanded: show }"
      type="text"
      [placeholder]="placeHolder || 'Search Job / Orders / Events...'"
      formControlName="jobOrderSearch"
      class="form-control"
      (focus)="isFocus($event)"
      (blur)="lostFocus($event)"
      (keyup)="onKeyboard($event)"
    />
    <span class="loading-spinner" *ngIf="loading$ | async">
      <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
    </span>
  </div>
  <div>
    <div #searchResult *ngIf="show" [ngClass]="'searchResult'">
      <table *ngIf="listOfJobOrders?.length > 0" class="border table table-striped shadow-lg w-100">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase">
              <label>description</label>
            </th>

            <th scope="col" class="text-uppercase text-nowrap">
              <label>Job Owner</label>
            </th>
            <th scope="col" class="text-uppercase"><label>Date</label></th>
          </tr>
        </thead>
        <tbody>
          <tr
            (click)="selectJobOrder(jobOrder)"
            *ngFor="let jobOrder of listOfJobOrders; let i = index"
            [ngClass]="i === indexFocus ? 'table-primary' : ''"
          >
            <td>
              
              <label>Description: </label
              ><ngb-highlight [result]="jobOrder.description" [term]="jobOrderSearchForm.get('jobOrderSearch').value"> </ngb-highlight>
              <!-- adding sub heading below order Number, vehicle,  customer as task don't have these values-->
              <div *ngIf="jobOrder.orderNumber" class="mt-1 sub-heading d-flex justify-content-between">
                <span> <label>Order Number:</label> {{ jobOrder.orderNumber }}</span>
                <span><label>Vehicle:</label> {{ jobOrder.vehicle }}</span>
                <span><label>Rego:</label> {{ jobOrder.rego }}</span>
                <span><label>Customer:</label> {{ jobOrder.customer }}</span>
              </div>
            </td>

            <td>
              <ngb-highlight [result]="jobOrder.jobOwner" [term]="jobOrderSearchForm.get('jobOrderSearch').value"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="jobOrder.fitDate" [term]="jobOrderSearchForm.get('jobOrderSearch').value"></ngb-highlight>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>
